import React from 'react'
import Logo from '../components/logo/Logo'
import { Box, Container, Paper } from '@mui/material';
import { Outlet } from 'react-router';
import Footerfunc from '../footer/footer';
import { LoginBtn } from '../components/login-logout-btn/LoginBtn';

export default function HomepageMob() {
  return (
    <div className='home-mob'>
        <Paper
        sx={{backgroundColor:'black', textAlign:'center'}}
        >
           <Container><Logo /></Container>
        </Paper>
        <Container
        sx={{marginTop:'10px'}}
        ><LoginBtn /></Container>
        <Outlet></Outlet>
    </div>
  )
}

